(function(){
  if(window.__wfQuizBound)return;window.__wfQuizBound=true;
  function step(q,n){q.querySelectorAll('.wf-quiz-step').forEach(function(el){el.hidden=(el.getAttribute('data-step')!=String(n));});}
  var toastEl;
  function toast(msg){
    if(!toastEl){toastEl=document.createElement('div');toastEl.className='wf-qp-toast';document.body.appendChild(toastEl);}
    toastEl.innerHTML=msg;toastEl.classList.add('on');
    clearTimeout(toastEl.__t);toastEl.__t=setTimeout(function(){toastEl.classList.remove('on');},3200);
  }
  function bumpCart(){
    fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){
      var n=c.item_count;var dot=document.querySelector('.cartdot .dot');
      if(dot){dot.textContent=n;}
      else{var a=document.querySelector('.cartdot');if(a){var i=document.createElement('i');i.className='dot';i.textContent=n;a.appendChild(i);}}
    }).catch(function(){});
  }
  function quickAdd(btn){
    var id=btn.getAttribute('data-vid');if(!id||btn.classList.contains('added'))return;
    var orig=btn.textContent;btn.disabled=true;btn.textContent='Adding...';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:parseInt(id,10),quantity:1}]})})
      .then(function(r){if(!r.ok)throw 0;return r.json();})
      .then(function(d){
        btn.classList.add('added');btn.textContent='Added \u2713';btn.disabled=false;
        var nm=(d.items&&d.items[0]&&d.items[0].title)||'Item';
        bumpCart();
        toast('Added to cart <a href="/cart">View cart &rarr;</a>');
      })
      .catch(function(){btn.disabled=false;btn.textContent=orig;toast('Sorry, could not add that &mdash; please try again.');});
  }
  document.addEventListener('click',function(e){
    var add=e.target.closest('.wf-qp-add');
    if(add){e.preventDefault();quickAdd(add);return;}
    var opt=e.target.closest('.wf-quiz-opt');
    var q=e.target.closest('[data-wfquiz]');
    if(!q)return;
    if(opt&&opt.hasAttribute('data-key')){
      q.dataset.key=opt.getAttribute('data-key')||'';
      q.dataset.title=opt.getAttribute('data-title')||'';
      q.dataset.desc=opt.getAttribute('data-desc')||'';
      q.dataset.url=opt.getAttribute('data-url')||q.getAttribute('data-fallback');
      step(q,2);return;
    }
    if(opt&&opt.hasAttribute('data-type')){
      var t=opt.getAttribute('data-type');
      q.querySelector('[data-r-title]').innerHTML=q.dataset.title||'Your Regimen';
      q.querySelector('[data-r-desc]').textContent='For '+t+' hair: '+(q.dataset.desc||'');
      q.querySelector('[data-r-link]').setAttribute('href',q.dataset.url||q.getAttribute('data-fallback'));
      var pk=q.dataset.key||'';
      q.querySelectorAll('.wf-quiz-prev').forEach(function(el){el.hidden=(el.getAttribute('data-prevfor')!==pk);});
      step(q,3);return;
    }
    if(e.target.closest('[data-back]')){step(q,1);return;}
    if(e.target.closest('[data-restart]')){step(q,1);return;}
  });
})();
